export const pushStateEvent = new Event('pushstate');
